import {
  getReportingProxyHeaders,
  getReportingProxyUrl,
} from '../../../../utils/reportingClient';

const cleanUrl = value => String(value || '').trim().replace(/\/+$/, '');

const getReportingApiOrigin = configuredOrigin => cleanUrl(configuredOrigin);

export const getAiChatUrl = (options = {}) => {
  const origin = getReportingApiOrigin(options.reportingApi);
  return origin ? `${origin}/ai/chat` : getReportingProxyUrl('ai-chat');
};

const getActionForIntent = intent => {
  if (intent === 'vehicle-alerts') {
    return {
      actionLabel: 'Voir le rapport',
      actionPath: '/dashboard/alertes-vehicules',
    };
  }

  return {};
};

export const normalizeAiChatResponse = (payload = {}) => {
  const action = getActionForIntent(payload.intent);

  return {
    title: payload.title || 'MaxPark AI',
    message: payload.answer || payload.message || '',
    details: Array.isArray(payload.details) ? payload.details : [],
    mode: payload.mode || '',
    intent: payload.intent || '',
    ...action,
  };
};

export const loadAiChatResponse = async (message, options = {}) => {
  const fetchImpl = options.fetchImpl || (typeof fetch === 'function' ? fetch : null);

  if (!fetchImpl) {
    throw new Error('Impossible de joindre MaxPark AI: fetch non disponible.');
  }

  const authHeaders = options.reportingApi
    ? { Accept: 'application/json' }
    : await getReportingProxyHeaders();
  const response = await fetchImpl(getAiChatUrl(options), {
    body: JSON.stringify({
      history: options.history || [],
      message,
    }),
    headers: {
      ...authHeaders,
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  if (!response.ok) {
    throw new Error(`Impossible de joindre MaxPark AI (${response.status}).`);
  }

  return normalizeAiChatResponse(await response.json());
};
